/*
 * Implements Bootstrap form validation for all forms
 * https://getbootstrap.com/docs/4.0/components/forms/#validation
*/
export function initFormValidation() {
  const forms = document.getElementsByTagName('form');
  // Loop over them and prevent submission
  Array.prototype.filter.call(forms, function (form) {
    form.setAttribute('novalidate', '')
    form.addEventListener('submit', function (event) {
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    }, false);
  });
}
